import { render, staticRenderFns } from "./EditTeamForm.vue?vue&type=template&id=33178f77&"
import script from "./EditTeamForm.vue?vue&type=script&lang=ts&"
export * from "./EditTeamForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditTeamForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports